import { message } from 'antd';
import * as ACTIONS from 'app/actions/HistoryCampaignActions';

const initialState = {

    isLoadingTraining: false,
    ListTraining: [],

    isLoadingSpecialty: false,
    ListSpecialty: [],

    isLoadingProgramCom: false,
    ListProgramCom: [],

    isLoadingProcedureMaterial: false,
    ListProcedureMaterial: [],

    isLoadingHistoryCampaign: false,
    ListHistoryCampaign: [],

    filter: {
        ListTraining: [],
        ListSpecialty: [],
        ListProgramCom: [],
        ListProcedureMaterial: []
    },

    pagination: {
        current: 1,
        pageSize: 25,
        total: 0,
        column: '',
        order: ''
    },
    isLoadExport: false, 
};

export const HistoryCampaignReducer = (state = initialState, action) => {
    switch(action.type) {
        //Filtro Combo Training
        case ACTIONS.GET_TRAINING_REQUEST:
            return {
                ...state,
                isLoadingTraining: true
            }
        case ACTIONS.GET_TRAINING_SUCCESS:
            return {
                ...state,
                isLoadingTraining: false,
                ListTraining: action.payload
            }
        case ACTIONS.GET_TRAINING_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadingTraining: false
            }
         //Filtro Combo specialty
         case ACTIONS.GET_SPECIALTYORSYSTEM_REQUEST:
            return {
                ...state,
                isLoadingSpecialty: true
            }
        case ACTIONS.GET_SPECIALTYORSYSTEM_SUCCESS:
            return {
                ...state,
                isLoadingSpecialty: false,
                ListSpecialty: action.payload
            }
        case ACTIONS.GET_SPECIALTYORSYSTEM_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadingSpecialty: false
            }
        //Filtro Combo CommunicationProgram
        case ACTIONS.GET_COMMUNICATIONPROGRAM_REQUEST:
            return {
                ...state,
                isLoadingProgramCom: true
            }
        case ACTIONS.GET_COMMUNICATIONPROGRAM_SUCCESS:
            return {
                ...state,
                isLoadingProgramCom: false,
                ListProgramCom: action.payload
            }
        case ACTIONS.GET_COMMUNICATIONPROGRAM_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadingProgramCom: false
            }
        //Filtro Combo ProcedureMaterial
        case ACTIONS.GET_PROCEDUREMATERIAL_REQUEST:
            return {
                ...state,
                isLoadingProcedureMaterial: true
            }
        case ACTIONS.GET_PROCEDUREMATERIAL_SUCCESS:
            return {
                ...state,
                isLoadingProcedureMaterial: false,
                ListProcedureMaterial: action.payload
            }
        case ACTIONS.GET_PROCEDUREMATERIAL_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadingProcedureMaterial: false
            }

        //Obtiene los History Camapign
        case ACTIONS.FETCH_HISTORYCOMPAIGN_REQUEST:
            return {
                ...state,
                isLoadingHistoryCampaign: true
            }
        case ACTIONS.FETCH_HISTORYCOMPAIGN_SUCCESS:
            return {
                ...state,
                isLoadingHistoryCampaign: false,
                ListHistoryCampaign: action.payload,
                pagination: {...state.pagination, current: action.current, total: action.payload.length > 0 ? action.payload[0].totalCount : 0 }
            }
        case ACTIONS.FETCH_HISTORYCOMPAIGN_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadingHistoryCampaign: false
            }
           //Guarda los filtros
        case ACTIONS.SAVE_FILTER:
            return {
                ...state,
                filter: action.payload
            }

        //Guarda el paginador
        case ACTIONS.SAVE_PAGINATION:
            return {
                ...state,
                pagination: action.payload
            }

        //Exporta los datos
        case ACTIONS.EXPORT_HISTORYCOMPAIGN_REQUEST:
            return {
                ...state,
                isLoadExport: true
            }
        case ACTIONS.EXPORT_HISTORYCOMPAIGN_SUCCESS:
            return {
                ...state,
                isLoadExport: false
            }
        case ACTIONS.EXPORT_HISTORYCOMPAIGN_FAILURE:
            message.error(action.payload);
            return {
                ...state,
                isLoadExport: false
            }

        case ACTIONS.CLEAR_HISTORYCAMPAING:
            return{
                ...state,
                ListHistoryCampaign:[],
                pagination: {...state.pagination, total:  0 },
                

            }
        //Limpia el reducer
        case ACTIONS.CLEAR_REDUCER:
            return initialState;

        default:
            return state; 
  
    }
}

